import { render, staticRenderFns } from "./kadarrespon.vue?vue&type=template&id=6b40f5f2&scoped=true"
import script from "./kadarrespon.vue?vue&type=script&lang=js"
export * from "./kadarrespon.vue?vue&type=script&lang=js"
import style0 from "./kadarrespon.vue?vue&type=style&index=0&id=6b40f5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40f5f2",
  null
  
)

export default component.exports